export const SESSION_CREATE = 'SESSION_CREATE';
export const SESSION_CREATE_DONE = 'SESSION_CREATE_DONE';

export const SESSION_DESTROY = 'SESSION_DESTROY';
export const SESSION_DESTROY_DONE = 'SESSION_DESTROY_DONE';

export const SESSION_VERIFY = 'SESSION_VERIFY';
export const SESSION_VERIFY_DONE = 'SESSION_VERIFY_DONE';
